import { render, staticRenderFns } from "./DashboardSidebar.vue?vue&type=template&id=c1f77340&scoped=true"
import script from "./DashboardSidebar.vue?vue&type=script&lang=js"
export * from "./DashboardSidebar.vue?vue&type=script&lang=js"
import style0 from "./DashboardSidebar.vue?vue&type=style&index=0&id=c1f77340&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1f77340",
  null
  
)

export default component.exports